export const CUSTOMER_GENDER_OPTIONS = [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
];
export const NO_CUSTOMER_GENDER_VALUE = 'NOT_SPECIFIED';
const CUSTOMER_GENDER_LABELS = {
    MALE: 'Male',
    FEMALE: 'Female',
};
export function formatCustomerGender(gender) {
    if (!gender || !Object.prototype.hasOwnProperty.call(CUSTOMER_GENDER_LABELS, gender)) {
        return 'Not specified';
    }
    return CUSTOMER_GENDER_LABELS[gender];
}
export function genderFormValue(gender) {
    return gender ?? NO_CUSTOMER_GENDER_VALUE;
}
export function genderValueFromForm(value) {
    return value === NO_CUSTOMER_GENDER_VALUE ? null : value;
}
